import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './containers/App/index.vue';
import router from './router';
import store from './store';
import { parsePpgHtml } from './helpers/ppgHtmlParser';

Vue.config.productionTip = false;
Vue.use(VueRouter);

const appIdName = 'app';

// Setup product page generator data
const ppgData = parsePpgHtml();

window.GarminAppBootstrap = {
  ...window.GarminAppBootstrap,
  ...ppgData,
};

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount(`#${appIdName}`);
